import styled from '@emotion/styled'
import React, { useRef, useEffect } from 'react'
import { DataContainerStyled } from 'src/ava/components/report/AvaReportBlockContainer'
import {
  DataIconContainer,
  DataIcon,
  DataTitle,
  DataTitleArrow,
  DataBody,
} from './SharedStyledComponents'

const DataHeader = styled.div`
  display: flex;
  align-items: center;

  @media screen and (max-width: 600px) {
    padding: 10px;
    margin: -10px;
  }
`

export default function ReportBlockContainer({
  icon,
  title,
  children,
  expanded = true,
  handleExpandedTab,
  isTitleLink,
  onTitleClick,
}: {
  icon: any
  title: string
  children: any
  expanded?: boolean
  handleExpandedTab?: (string) => void
  isTitleLink?: boolean
  onTitleClick?: (ev?: any) => void
}) {
  const dataRef = useRef(null)

  const handleHidden = () => {
    if (expanded) {
      dataRef.current?.classList.add('hidden')
      setTimeout(() => {
        handleExpandedTab(title)
      }, 300)
    } else {
      dataRef.current?.classList.remove('hidden')
      handleExpandedTab(title)
    }
  }

  useEffect(() => {
    dataRef.current?.classList.remove('hidden')
  }, [expanded])

  return (
    <DataContainerStyled>
      <DataHeader onClick={() => handleHidden()}>
        {icon && (
          <DataIconContainer>
            <DataIcon src={icon} />
          </DataIconContainer>
        )}
        <DataTitle
          onClick={(ev) => {
            if (isTitleLink) {
              onTitleClick(ev)
            }
          }}
          isLink={isTitleLink}
        >
          {title}
          <DataTitleArrow expanded={expanded} />
        </DataTitle>
      </DataHeader>
      <DataBody expanded={expanded} ref={dataRef}>
        {children}
      </DataBody>
    </DataContainerStyled>
  )
}

ReportBlockContainer.defaultProps = {
  expanded: false,
  handleExpandedTab: () => {},
  isTitleLink: false,
  onTitleClick: () => {},
}
